<template>

  <div 
    class       = "label"
    :style      = "labelStyle"
    @mouseenter = "$emit('enter');"
    @mouseleave = "$emit('leave');"
  >
    {{ label }}

    <v-icon
      v-if        = "removeable"
      small
      class       = "ml-2"
      @click.stop = "$emit('remove');"
    >
      mdi-close
    </v-icon>
  </div>

</template>

<script>

// #region Constants

const DEFAULT_BACKGROUND_COLOR  = '#00000099';
const DEFAULT_BORDER_COLOR      = '#ffffff66';

// #endregion Constants

export default {

  // #region Properties

  name:  'ScrubBarLabel',
  props: {
    label:      String,
    background: String,
    border:     String,
    invisible:  Boolean,
    removeable: Boolean,
  },
  computed: {
    labelStyle() {
      const backgroundColor = this.background || DEFAULT_BACKGROUND_COLOR;
      const borderColor = this.border || DEFAULT_BORDER_COLOR;

      return {
        'background': backgroundColor,
        'border':     `1px solid ${borderColor}`,
        'opacity':    this.invisible ? '0%' : '100%'
      };
    }
  }

  // #endregion Properties

}

</script>

<style lang="scss" scoped>

.label {
  font-size:      12px;
  border-radius:  3px;
  padding:        4px;
  transition:     opacity 0.2s ease-out;

  display:        flex;
  align-items:    center;
}

</style>